import React from "react"
import Template from "../../components/Template"
import img1 from "../../images/indicators/indicators.jpg"
import Translations from "../../../components/Translations"

function AV() {
    const Content = () => {
        return (
            <div className={`flex flex-col gap-5`}>
                <img src={img1} alt='/' className={`border border-gray-700 mt-5 mb-5 w-[20%]`}></img>
                <p className={`text-lg`}><Translations category={"docsAV"} id={1}/></p>
                <p className={`text-lg`}><Translations category={"docsAV"} id={2}/></p>
                <p className={`text-lg`}>
                    <Translations category={"docsAV"} id={3}/>
                    <li><Translations category={"docsAV"} id={4}/></li>
                    <li><Translations category={"docsAV"} id={5}/></li>
                    <li><Translations category={"docsAV"} id={6}/></li>
                </p>
                <p className={`text-lg`}><Translations category={"docsAV"} id={7}/></p>
            </div>
        )
    }
    const config = {
        title: <Translations category={"docs"} id={23}/>,
        previousLink: '/docs/average-candle-length',
        previousTitle: <Translations category={"docs"} id={22}/>,
        nextLink: '/docs/pump-average-volume',
        nextTitle: <Translations category={"docs"} id={24}/>,
        content: Content(),
    }

    return (
        <Template config={config}/>
    )
}

export default AV